import firebase from 'src/config/firebase'; // firebase

const extractSubString = (s, prefix, suffix) => {
  var i = s.indexOf(prefix);
  if (i >= 0) {
    s = s.substring(i + prefix.length);
  } else {
    return '';
  }
  if (suffix) {
    i = s.indexOf(suffix);
    if (i >= 0) {
      s = s.substring(0, i);
    } else {
      return '';
    }
  }
  return s;
};

const deleteStorageFile = async (content,extractPath, extractUrl) => {
    return new Promise(async (resolve, reject) => {
        const storageKey = extractSubString(content, extractPath, '?alt');
        if (!storageKey) resolve();

        const decodeStorageKey = decodeURIComponent(storageKey);
        firebase.storage().ref(`${extractUrl}/${decodeStorageKey}`).delete()
        .then(()=> {
            resolve();
        })
        .catch(error => {
            reject(error.message);
        })
    })
}

export default deleteStorageFile;